module.exports = __webpack_public_path__ + "img/w4.28cb74ab.webp";